// 造价分析 --- 清标
import request from '../request.js'

// 清标 --- 查询投标单位名称是否重复（郑志会）
/**
 *
 * @param {name} params
 * { "name":"合肥工程施工"     // -----投标单位名称 }
 * @returns
 * {
        "msg": "投标单位名称重复！",
        "code": 0,
        "data": "合肥工程施工",
        "operationCode": 2,
        "operationType": "1",
        "version": "1",
        "accessTime": "2021-09-24 14:32:07"
    }
 */
export const checkName = function (data) {
    return request({
        method: 'post',
        data,
        url: 'bidTenderer/selectWhetherRepeat',
    })
}


// 清标 --- 新增文件-解析文件xml（郑志会）
/**
 *
 * @param {file} params
 * { "file":"合肥工程施工"     // -----投标单位名称 }
 * @returns
 */
export const parseXml = function (data, progressFn, index) {
    return request({
        url: 'bidCostDetail/bidCostAnalysisFile',
        method: 'post',
        config: {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        },
        onUploadProgress: function (progressEvent) {
            if (progressFn) {
                progressFn(progressEvent, index)
            }
        },
        data
    })
}


// 清标 ---  选择xml文件点击确定跳转页面中单位工程的下拉列表接口 （郑志会）
/**
 *
 * @param {id} params
 * { "id":"1435437180372783104"   // -----项目id }
 * @returns 
 * "data": [
        {
            "isData": 1,
            "name": "合巢产业新城郭塘新村，映湖公租房项目一标段-测试  |  1#  |  1#土建",
            "id": "1435444744728743937"
        }
    ],
 */
export const getSelectUnit = function (data) {
    return request({
        method: 'post',
        data,
        url: 'bidCostDetail/selectDanWeiByProject',
    })
}


// 清标 ---  查询投标单位列表数据 （郑志会）
/**
 *
 * @param {projectId} params projectId
 * @returns
 */
export const getUnitList = function (data) {
    return request({
        method: 'post',
        data,
        url: 'bidTenderer/selectProjectAll',
    })
}

// 清标 ---  最终保存投标造价接口 （郑志会）
/**
 *
 * @param {params} params
 * @returns
 */
export const saveData = function (data) {
    return request({
        method: 'post',
        data,
        url: 'bidCostDetail/bidCostSave',
    })
}

// 清标 ---  清标获取控制价信息 （张卫华）
/**
 *
 * @param {params} params
 {
    priceCode: '', // 价格码值
    unitProjectIdList: [],  // 当前选择的 树ID
}
 * @returns
 */
export const getSixCalculationPrice = function (data) {
    return request({
        method: 'post',
        data,
        url: 'billRule/getSixCalculationPrice',
    })
}

// 清标 ---  手动分析 （张卫华）
/**
 *
 * @param {params} params
{
    id: '', // 规则ID
    unitProjectIdList: [],  // 当前选择的 树ID
    tendererId: ''  // 投标报价单位id
}
 * @returns
 */
export const loadData = function (data) {
    return request({
        method: 'post',
        data,
        url: 'billRule/manualAnalysis',
    })
}

// 清标 ---  获取分析规则列表 （张卫华）
/**
 *
 * @param {params} params {}
 * @returns
 */
export const getRulesList = function (data) {
    return request({
        method: 'post',
        data,
        url: 'billRule/getPersonalSelectList',
    })
}